import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsRecordStatus, PmsRecordStatus } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsRecordStatus>
    useData={usePmsRecordStatus}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
